/**
 * @description: 菜单数据存储
 * @author: linwen linwen@fjxhx.com
 * @createDate: 2020-10-22 22:06
 * @param: 菜单数据存储
 * @return:
*/

const AddRoutersKey = 'AddRouters'

export function getAddRouters() {
  return JSON.parse(window.sessionStorage.getItem(AddRoutersKey))
}

export function setAddRouters(routers) {
  return window.sessionStorage.setItem(AddRoutersKey, JSON.stringify(routers))
}

export function removeAddRouters() {
  return window.sessionStorage.removeItem(AddRoutersKey)
}


const RoutersKey = 'Routers'

export function getRouters() {
  return JSON.parse(window.sessionStorage.getItem(RoutersKey))
}
/**
 * @description: 设置路由
 * @author: linwen linwen@fjxhx.com
 * @createDate: 2020-10-22 22:57
 * @param: 设置路由
 * @return:
*/
export function setRouters(routers) {
  return window.sessionStorage.setItem(RoutersKey, JSON.stringify(routers))
}

export function removeRouters() {
  return window.sessionStorage.removeItem(RoutersKey)
}

const MainMenuKey = 'MainMenu'

export function getMainMenu() {
  return JSON.parse(window.sessionStorage.getItem(MainMenuKey))
}

export function setMainMenu(routers) {
  return window.sessionStorage.setItem(MainMenuKey, JSON.stringify(routers))
}

export function removeMainMenu() {
  return window.sessionStorage.removeItem(MainMenuKey)
}

const SettingMenuKey = 'SettingMenu'

export function getSettingMenu() {
  return JSON.parse(window.sessionStorage.getItem(SettingMenuKey))
}

export function setSettingMenu(routers) {
  return window.sessionStorage.setItem(SettingMenuKey, JSON.stringify(routers))
}

export function removeSettingMenu() {
  return window.sessionStorage.removeItem(SettingMenuKey)
}

const CurrentMenuKey = 'CurrentMenu'

export function getCurrentMenu() {
  return JSON.parse(window.sessionStorage.getItem(CurrentMenuKey))
}

export function setCurrentMenu(routers) {
  return window.sessionStorage.setItem(CurrentMenuKey, JSON.stringify(routers))
}

export function removeCurrentMenu() {
  return window.sessionStorage.removeItem(CurrentMenuKey)
}



// WEBPACK FOOTER //
// ./src/utils/menu.js